import React from "react";

interface TripFlightStopProps {
    hop: {
        stop: {
            inArrivalAirportCode: string;
            in: string;
            inFull: string;
        };
    };
}

const TripFlightStop: React.FC<TripFlightStopProps> = ({ hop }) => {
    if (!hop || !hop.stop) return null;
    return (
        <>
            <div className="row separator"></div>
            <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4 stop">
                    {`${hop.stop.inFull} (in)`}
                </div>
                <div className="col-md-4"></div>
            </div>
        </>
    );
}

export default TripFlightStop;